//@ts-nocheck
import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import "@banno/jha-wc/src/forms/jha-form-date-input/jha-form-date-input";
import "@banno/jha-wc/src/forms/jha-form-row/jha-form-row";
import "@banno/jha-wc/src/forms/jha-form-input-base/jha-form-input";
import "@banno/jha-wc/src/forms/jha-form-text-input/jha-form-text-input";
import "@banno/jha-wc/src/forms/jha-form-select/jha-form-select";
import { Apis } from "../../utils/api-constants";
import { getRequest } from "../../utils/jha-fetch";
import { getRoleData } from "../../utils/getRoleData";
import formElementMixin from "@banno/jha-wc/src/js/mixins/form-element-mixin";
import Cookies from "js-cookie";
import { decryptValue, stringComparison, getCurrentDateTimeInTimeZone, getTimeZoneIdentifier, getEnvApiUrl } from "../../utils/app-utils";
import { schedulerFieldLabel } from "../../utils/datetime-display";
import "@banno/jha-wc/src/jha-tooltip/jha-tooltip";
import { dateFormatter } from "../../utils/dateFormatter";
@customElement("scheduler-view")
export class SchedulerView extends formElementMixin(LitElement) {
  constructor() {
    super();
    this.hours = Array.from({ length: 24 }, (_, i) => ({
      name: i.toString().padStart(2, '0'),
      value: i.toString().padStart(2, '0'),
    }));
    this.minutes = Array.from({ length: 60 }, (_, i) => ({
      name: i.toString().padStart(2, '0'),
      value: i.toString().padStart(2, '0'),
    }));
  }
  @property({ type: Object })
  formData: {
    SchedulerName: "",
    Description: "",
    Type: "",
    RateValue: "",
    RateConfig: "",
    CronValue: "",
    CronHour: "",
    CronMonthDay: "",
    CronMonth: "",
    CronWeekDay: "",
    CronYear: "",
    StartDate: "",
    TimeZone: "",
    StartHour: "",
    StartMinute: "",
    EndDate: "",
    EndTime: "",
    Expression: "",
    valid: false,
    isEdit: false,
    isRateDisabled: true,
    isCronDisabled: false
  }
  @property()
  isRateDisabled: true
  @property()
  currentExpression: ""
  @property()
  minDate: Date
  @property()
  isCronDisabled: false
  /** Cron inputs stay unrendered until cron schedules are supported. */
  private readonly showCronInputs = false;
  static readonly styles = css`
    :host {
      display: block;
      padding: 20px;
    }
    #genInfoDiv {
      padding: 0 15px;
    }
    @media (prefers-color-scheme: dark) {
      h2 {
        color: #a3d4ff;
      }
    }
    @media (prefers-color-scheme: light) {
      h2 {
        color: #06185f;
      }
    }
    h2 {
      margin-top: 24px;
      margin-bottom: 16px;
      font-size: 24px;
      font-weight: 600;
    }
    h2:first-child {
      margin-top: 0;
    }
    .form-row {
      display: flex;
      flex-wrap: wrap;
      gap: 16px;
      margin-bottom: 16px;
      align-items: flex-start;
    }
    #expInfoDiv {
      display: flex;
      gap: 16px;
      align-items: flex-start;
    }
    jha-form-text-input {
      width: 120px;
    }
    jha-form-select {
      width: 200px;
    }
    jha-form-date-input {
      width: 200px;
    }
    .time-selector {
      display: flex;
      gap: 8px;
      align-items: flex-end;
    }
    .time-selector span {
      margin-bottom: 12px;
      font-size: 18px;
    }
    .time-selector jha-form-select {
      width: 70px;
    }
    #expInfoDiv jha-form-select {
      width: 160px;
    }
  `;
  @property({ type: Array })
  selectOptions = [];
  @property({ type: Array })
  timezoneOptions = [];
  @property({ type: Array })
  rates = [];
  @property({ type: Array })
  schedulerTypes = [];
  @property({ type: Boolean })
  isReadOnlyUser = /readonly/i.test(decryptValue(Cookies.get("userRole")));
  @property({ type: Array })
  hours = [];
  @property({ type: Array })
  minutes = [];
  @property({ type: Boolean })
  startDateWarning = false;

  setScheduleType(key) {
    switch (key) {
      case "rate":
        this.isRateDisabled = false;
        this.formData.isRateDisabled = false;
        this.isCronDisabled = true;
        this.formData.isCronDisabled = true;
        break;
      case "cron":
        this.isRateDisabled = true;
        this.formData.isRateDisabled = true;
        this.isCronDisabled = false;
        this.formData.isCronDisabled = false;
        break;
    }
    this.currentExpression = key;
  }
  formRateExpression() {
    if (this.formData.RateValue != "" && this.formData.RateConfig != "" && this.formData.RateValue != undefined && this.formData.RateConfig != undefined) {
      this.formData.Expression = "rate".concat("(", this.formData.RateValue.concat(" ", this.formData.RateConfig, ")").toLowerCase());
      this.checkifAllFieldsValid("rate");
    }
    else {
      this.checkifAllFieldsValid("rate");
    }
  }
  formCronExpression(cronValue: string, cronHour: string, cronMonthDay: string, cronMonth: string, cronWeekday: string, cronYear: string) {
    if (this.formData.CronHour != "" && this.formData.CronMonthDay != "" && this.formData.CronMonth != "" && this.formData.CronWeekDay != "" && this.formData.CronYear != "") {
      this.formData.Expression = "cron".concat("(", cronValue.concat(this.formData.CronHour, this.formData.CronMonthDay, this.formData.CronMonth, this.formData.CronWeekDay, this.formData.CronYear, ")").toLowerCase());
      this.checkifAllFieldsValid("cron");
    }
  }

  async connectedCallback() {
    super.connectedCallback();
    // getEnvApiUrl: localhost-only; .env.local never ships — no effect in prod, test, staging, or CI builds.
    const timezones = await getRequest(getEnvApiUrl(Apis.SCHEDULER_TIMEZONE));
    enum TimeZone {
      us_central = "US Central",
      us_eastern = "US Eastern",
      us_pacific = "US Pacific",
      us_mountain = "US Mountain",
      us_alaska = "US Alaska",
    }
    this.timezoneOptions = getRoleData(timezones?.list ?? []).map(timeZone => {
      timeZone.name = TimeZone[timeZone.value];
      return timeZone;
    });
    const types = await getRequest(getEnvApiUrl(Apis.SCHEDULER_TYPE));
    this.schedulerTypes = getRoleData(types?.list ?? []);
    this.schedulerTypes = this.schedulerTypes?.filter((type) => stringComparison(type.value, "rate"))
    const rate = await getRequest(getEnvApiUrl(Apis.SCHEDULER_RATE));
    this.rates = getRoleData(rate?.list ?? []);
    this.rates = this.rates?.filter((type) => !stringComparison(type.value, "seconds"))
    if (this.formData.isEdit) {
      this.formData.valid = true;
      const splitExpression = this.formData.Expression.split("(");
      const existingDate = new Date(this.formData.StartDate);
      const today = getCurrentDateTimeInTimeZone(getTimeZoneIdentifier(this.formData.TimeZone));
      if (existingDate < today) {
        this.minDate = dateFormatter(existingDate, 0);
      }
      else {
        this.minDate = dateFormatter(today, 0);
      }
      if (stringComparison(splitExpression[0], "rate")) {
        this.formData.Type = "rate";
        this.formData.isRateDisabled = false;
        this.formData.isCronDisabled = true;
        const splitValue = splitExpression[1].split(" ")
        this.formData.RateValue = splitValue[0];
        this.formData.RateConfig = splitValue[1].slice(0, -1);
      }
      else if (stringComparison(splitExpression[0], "cron")) {
        this.formData.Type = "cron";
        this.formData.isRateDisabled = true;
        this.formData.isCronDisabled = false;
        const splitValue = splitExpression[1].split(" ")
        this.formData.CronHour = splitValue[0];
        this.formData.CronMonth = splitValue[1];
        this.formData.CronMonthDay = splitValue[2];
        this.formData.CronWeekDay = splitValue[3];
        this.formData.CronYear = splitValue[4].slice(0, -1);
      }
      this.currentExpression = splitExpression[0];
      // This will properly set formData.valid based on actual field values
      this.checkifAllFieldsValid(splitExpression[0]);
    }
  }
  checkifAllFieldsValid(expression) {
    let isValid = true;
    if (expression === undefined || expression === null || expression === "") {
      expression = this.formData.Type;
    }

    if (!this.formData.StartDate) {
      isValid = false;
    }
    if (!this.formData.Type) {
      isValid = false;
    }
    if ((stringComparison(expression, "rate")) && (this.formData.RateValue === "" || this.formData.RateConfig === "" || this.formData.RateValue === undefined || this.formData.RateConfig === undefined)) {
      isValid = false;
    }
    else if ((stringComparison(expression, "cron")) && (this.formData.CronHour === "" || this.formData.CronMonthDay === "" || this.formData.CronMonth === "" || this.formData.CronWeekDay === "" || this.formData.CronYear === "" || this.formData.CronHour === undefined || this.formData.CronMonthDay === undefined || this.formData.CronMonth === undefined || this.formData.CronWeekDay === undefined || this.formData.CronYear === undefined)) {
      isValid = false;
    }

    this.formData.valid = isValid;
    this.requestUpdate();
  }
  checkifTimeIsValid(e) {
    const regex = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;
    if (!(regex.test(e.target.value))) {
      this.checkifAllFieldsValid(this.currentExpression);
    }
  }
  handleTimezoneChange(event) {
    const selectedTimezone = event.target.value;
    this.formData.TimeZone = selectedTimezone;

    if (!selectedTimezone) {
      this.minDate = null;

    } else {
      const today = getCurrentDateTimeInTimeZone(getTimeZoneIdentifier(selectedTimezone));
      this.minDate = dateFormatter(today, 0);
    }
    this.formData.StartDate = null;
    this.formData.StartHour = '00';
    this.formData.StartMinute = '00';
    this.startDateWarning = true;
    this.checkifAllFieldsValid(this.currentExpression);
    this.requestUpdate();
  }
  handleDateChange(event) {
    this.startDateWarning = false;
    if (event.target.value != "") {
      const selectedDate = event.target.value;
      this.formData.StartDate = selectedDate;
      if (this.formData.StartHour == undefined) {
        this.formData.StartHour = '00';
      }
      if (this.formData.StartMinute == undefined) {
        this.formData.StartMinute = '00';
      }
      this.requestUpdate();
    }
    else {
      this.formData.StartDate = null;
      this.startDateWarning = true;
    }
    this.checkifAllFieldsValid(this.currentExpression);
  }

  render() {
    this.checkifAllFieldsValid(this.currentExpression);
    this.dispatchEvent(
      new CustomEvent("onSchedulerChange", {
        detail: this.formData,
        bubbles: true,
        composed: true,
      }));
    return html`
      <form>
      <div id="genInfoDiv">  
        <h2>Date & Time Info</h2>
        <div class="form-row">
         <jha-tooltip bottom text="Select Time Zone from dropdown list">
          <jha-form-select
            outline
            .options=${this.timezoneOptions ?? []}
            lableKey="name"
            valueKey="value"
            label="Timezone"
            required
            warning="Timezone is required"
            emptyOptionLabel="Select Timezone"
            ?disabled=${this.isReadOnlyUser}
            data-id="TimeZone"
            data-auto-id="TimeZoneSelect"
            .value=${this.formData.TimeZone}
             @change=${this.handleTimezoneChange}
            isValid
          ></jha-form-select>
        </jha-tooltip>
        <jha-tooltip bottom text="Select Start Date & Time from date picker">
          <jha-form-date-input
            required
            min=${this.minDate}
            max="infinity"
            warning="Start Date & Time is required"            
            ?showWarning=${this.startDateWarning}
            label=${schedulerFieldLabel("Start Date & Time", this.formData.TimeZone)}
            id
            outline
            type="date"
            onkeydown="return false"
            minlength="0"
            maxlength="10"
            role="textbox"
            data-id="StartDate"
            data-auto-id="StartDateInput"
            ?disabled=${!this.formData.TimeZone || this.isReadOnlyUser} 
            .value=${this.formData.StartDate}
             @change=${this.handleDateChange}
          >
          </jha-form-date-input>
        </jha-tooltip>
       
        <jha-tooltip bottom text="Enter Start Time">
  <div class="time-selector">

 <jha-form-select
required
  label="HH"
            .options=${this.hours ?? []}
            lableKey="name"
            valueKey="value"
            label="Select"
            data-id="StartHour"
            data-auto-id="StartHourInput"
            ?disabled=${!this.formData.StartDate || this.isReadOnlyUser}
            .value=${this.formData.StartHour}
             @change=${this.inputValueChange}  
          ></jha-form-select>

<span>:</span>

<jha-form-select
  required
  label="MM"
  .options=${this.minutes ?? []}
  data-id="StartMinute"
  data-auto-id="StartMinuteInput"
  ?disabled=${!this.formData.StartDate || this.isReadOnlyUser}
  .value=${this.formData.StartMinute}
  @change=${this.inputValueChange}
>
</jha-form-select>

  </div>
</jha-tooltip>

        </div>
        <h2>Expression Info</h2>
        <div class="form-row">

      <jha-tooltip bottom text="Select Schedule Type from dropdown list">
        <jha-form-select
        outline
        .options=${this.schedulerTypes ?? []}
        label="Schedule Type"
        lableKey="name"
        valueKey="value"
        isValid
        data-id="Type"
        data-auto-id="TypeSelect"
        ?disabled=${this.isReadOnlyUser}
        @click=${() => this.setScheduleType(this.formData.Type)}
        .value=${this.formData.Type}
         @change=${this.inputValueChange}
        required
        warning="Schedule Type is required"
        emptyOptionLabel="Select Schedule Type"
      ></jha-form-select>
      </jha-tooltip>
        ${!this.showCronInputs || this.formData.isRateDisabled === false ? html`
        <div id="expInfoDiv"> 
        <jha-tooltip bottom text="Enter Rate Expression">       
          <jha-form-text-input
            label="Rate Expression"
            required
            pattern="^\\d{1,2}$"
            warning="Invalid/Blank Rate Expression"
            type="text"
            placeholder="Value"
            data-id="RateValue"
            data-auto-id="RateValueInput"
            ?disabled=${this.isReadOnlyUser}
            .value=${this.formData.RateValue}
             @change=${this.inputValueChange}
             @keyup=${this.formRateExpression}
             maxlength="2"
            outline
          ></jha-form-text-input>
          </jha-tooltip>
          <jha-tooltip bottom text="Select Rate Configuration from dropdown list">
          <jha-form-select
            outline
            .options=${this.rates ?? []}
            lableKey="name"
            valueKey="value"
            label="Select"
            data-id="RateConfig"
            data-auto-id="RateConfigSelect"
            ?disabled=${this.isReadOnlyUser}
            .value=${this.formData.RateConfig}
             @change=${this.inputValueChange}
             @focusout=${this.formRateExpression}
            isValid
            emptyOptionLabel="Select Expression"
          ></jha-form-select>
          </jha-tooltip>
        </div>` : html`
        <div id="expInfoDiv">
        <jha-tooltip bottom text="Enter Minute Cron Expression">
          <jha-form-text-input
            label="Cron Expression"
            required
            warning="Cron Expression is required"
            type="text"
            placeholder="Min"
            data-id="CronValue"
            data-auto-id="CronValueInput"
            ?disabled=${this.isReadOnlyUser}
            .value=${this.formData.CronValue}
             @change=${this.inputValueChange}
             @focusout=${this.formCronExpression}
             maxlength="256"
            outline
          ></jha-form-text-input>
          </jha-tooltip>
          <jha-tooltip bottom text="Enter Hour Cron Expression">
          <jha-form-text-input
            pattern="^\\d{1,2}$"
            required
            warning="Invalid/Blank hours"
            type="text"
            placeholder="Hour"
            label="Hour"
            data-id="CronHour"
            data-auto-id="CronHourInput"
            ?disabled=${this.isReadOnlyUser}
            .value=${this.formData.CronHour}
             @change=${this.inputValueChange}
             @focusout=${this.formCronExpression}
             maxlength="2"
            outline
          ></jha-form-text-input>
          </jha-tooltip>
          <jha-tooltip bottom text="Enter Month Day Cron Expression">
          <jha-form-text-input
          pattern="^\d{1,2}$"
          required
          warning="Invalid/Blank days"
            type="text"
            placeholder="Month Day"
            label="Month Day"
            data-id="CronMonthDay"
            data-auto-id="CronMonthDayInput"
            ?disabled=${this.isReadOnlyUser}
            .value=${this.formData.CronMonthDay}
             @change=${this.inputValueChange}
             @focusout=${this.formCronExpression}
             maxlength="2"
            outline
          ></jha-form-text-input>
          </jha-tooltip>
          <jha-tooltip bottom text="Enter Month Cron Expression">
          <jha-form-text-input
          pattern="^\d{1,2}$"
          required
          warning="Invalid/Blank month"
            type="text"
            placeholder="Month"
            label="Month"
            data-id="CronMonth"
            data-auto-id="CronMonthInput"
            maxlength="2"
            ?disabled=${this.isReadOnlyUser}
            .value=${this.formData.CronMonth}
             @change=${this.inputValueChange}
             @focusout=${this.formCronExpression}
            outline
            maxlength="2"
          ></jha-form-text-input>
          </jha-tooltip>
          <jha-tooltip bottom text="Enter Week Day Cron Expression">
          <jha-form-text-input
          pattern="^\d{1,2}$"
          required
          warning="Invalid/Blank week day"
            type="text"
            placeholder="Week Day"
            label="Week Day"
            data-id="CronWeekDay"
            data-auto-id="CronWeekDayInput"
            maxlength="2"
            ?disabled=${this.isReadOnlyUser}
            .value=${this.formData.CronWeekDay}
             @change=${this.inputValueChange}
             @focusout=${this.formCronExpression}
            outline
          ></jha-form-text-input>
          </jha-tooltip>
          <jha-tooltip bottom text="Enter Year Cron Expression">
          <jha-form-text-input
          pattern="^\d{1,4}$"
          required
          warning="Invalid/Blank year"
            type="text"
            placeholder="Year"
            label="Year"
            data-id="CronYear"
            data-auto-id="CronYearInput"
            maxlength="4"
            ?disabled=${this.isReadOnlyUser}
            .value=${this.formData.CronYear}
             @change=${this.inputValueChange}
             @focusout=${this.formCronExpression}
            outline
          ></jha-form-text-input>
          </jha-tooltip>
          </jha-form-row>
        </div>`}        
        </div>
      </div>
      </form>
    `;
  }
}
declare global {
  interface HTMLElementTagNameMap {
    "scheduler-view": SchedulerView;
  }
}